import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { FaLock } from 'react-icons/fa6';

/**
 * Label + BaseSelect pair with a "locked" fallback that swaps the control for a lock icon.
 *
 * `onChange` receives the selected option's raw value (or `''` when cleared), so callers keep
 * the same value contract they had with the native select this used to render.
 *
 * `disabled` has to be passed explicitly: react-select renders a div-based control, so an
 * ancestor `<fieldset disabled>` (the read-only wrapper this used to rely on) no longer
 * reaches it.
 *
 * @param {{
 *   label: string,
 *   value?: string | number,
 *   onChange?: (value: string) => void,
 *   options?: { value: string | number, label: React.ReactNode }[],
 *   className?: string,
 *   selectClassName?: string,
 *   placeholder?: string,
 *   locked?: boolean,
 *   disabled?: boolean,
 * }} props
 * @returns A react component
 */
export default function LabeledSelect({
  label,
  value,
  onChange,
  options = [],
  className = '',
  selectClassName = '',
  placeholder = '-Select-',
  locked = false,
  disabled = false,
}) {
  return (
    <div className={`d-flex flex-column ${className}`}>
      <div className="mb-1 fw-medium">{label}</div>
      {locked ? (
        <FaLock
          className="text-secondary fs-5"
          title={`${label.replace(':', '').trim()} not accessible`}
        />
      ) : (
        <BaseSelect
          isSearchable
          classNames={{
            control: () => `global-action-builder-field ${selectClassName}`.trim(),
          }}
          selectProps={{
            options,
            value: findSelectOption(options, value),
            placeholder,
            isDisabled: disabled,
            onChange: (option) => onChange?.(option?.value ?? ''),
          }}
        />
      )}
    </div>
  );
}
